import React from 'react';
import { CountryFlag } from '@components/moleculs/country-flag';
import { DEFAULT_FLAG_STYLE } from '@components/moleculs/country-flag-adornment/constants';
import type { CountryFlagAdornmentProps } from '@components/moleculs/country-flag-adornment/types';

// Flag shown as the input's `startAdornment` for single-select country pickers
// (replaces the old `useCountryAutocomplete().renderInputFlag`). Renders nothing when empty.
export const CountryFlagAdornment: React.FC<CountryFlagAdornmentProps> = ({
    countryCode,
    style = DEFAULT_FLAG_STYLE,
}) => (countryCode ? <CountryFlag name={countryCode} style={style} /> : null);
